import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Container from '../components/layout/Container';
import MatchDetails from '../components/matches/MatchDetails';
import Loading from '../components/common/Loading';
import ErrorMessage from '../components/common/ErrorMessage';
import { getMatchDetails } from '../services/public-api';
import './MatchDetailsPage.css';

/**
 * MatchDetailsPage
 * Shows full match results with game-by-game details
 * T074: Match details page with full match results
 */
const MatchDetailsPage = () => {
  const { matchId } = useParams();
  const [match, setMatch] = useState(null);
  const [games, setGames] = useState([]);
  const [team1, setTeam1] = useState(null);
  const [team2, setTeam2] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (matchId) {
      fetchMatchDetails();
    }
  }, [matchId]);

  const fetchMatchDetails = async () => {
    setLoading(true);
    setError(null);

    try {
      const data = await getMatchDetails(matchId);
      setMatch(data.match);
      setGames(data.games || []);
      setTeam1(data.team1);
      setTeam2(data.team2);
    } catch (err) {
      setError(err.message || 'Failed to load match details');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container>
        <Loading size="large" />
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <ErrorMessage
          message={error}
          variant="error"
          onRetry={fetchMatchDetails}
        />
      </Container>
    );
  }

  if (!match) {
    return (
      <Container>
        <div className="not-found">
          <h1>Match Not Found</h1>
          <p>This match doesn't exist or hasn't been completed yet.</p>
        </div>
      </Container>
    );
  }

  return (
    <Container>
      <div className="match-details-page">
        <div className="page-header">
          {match.competitionId && (
            <Link to={`/competitions/${match.competitionId}`} className="back-link">
              ← Back to Competition
            </Link>
          )}
          <h1>Match Details</h1>
        </div>

        <MatchDetails
          match={match}
          games={games}
          team1={team1}
          team2={team2}
        />
      </div>
    </Container>
  );
};

export default MatchDetailsPage;
